<div class="modal-header" style="background-color: #cd5763;">
  <h3 class="modal-title">
    {{client.CLIENT_NAME}}
  </h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  <div class="modal-body-content">
    <div class="chart-section">
      <div class="flex-wrapper">
        <div class="single-chart">
          <svg viewBox="0 0 36 36" class="circular-chart green">
            <path class="circle-bg"
                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/>
            <path class="circle"
                  [attr.stroke-dasharray]="client.PERCENTILE_COMPLETE + ' 100'"
                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/>
            <text x="18" y="20.35" class="percentage">{{client.PERCENTILE_COMPLETE}}%</text>
          </svg>
        </div>
      </div>
    </div>
    <div class="details-section">
      <div class="client-details">
        <div class="detail-label">Return Filed</div>
        <div class="detail-value"
             [ngClass]="client.TAX_RETURN_FILED_2018 === 'Y' ? 'field-value-yes' : 'field-value-no'">
          {{client.TAX_RETURN_FILED_2018 === 'Y' ? 'YES' : 'NO'}}
        </div>
      </div>
      <div class="client-details">
        <div class="detail-label">Est Filing Date</div>
        <div class="detail-value">{{client.EST_FILING_DATE}}</div>
      </div>
      <div class="client-details">
        <div class="detail-label">Date Filed</div>
        <div class="detail-value">{{client.FILING_DATE}}</div>
      </div>
      <div class="client-details extra-space">
        <div class="detail-label">Extension Filed</div>
        <div class="detail-value"
             [ngClass]="client.EXT_FILED === 'Y' ? 'field-value-yes' : 'field-value-no'">
          {{client.EXT_FILED === 'Y' ? 'YES' : 'NO'}}
        </div>
      </div>
      <div class="client-details">
        <div class="detail-label">Extension Filing Date</div>
        <div class="detail-value">{{client.EXT_FILING_DATE}}</div>
      </div>
      <div class="client-details extra-space">
        <div class="detail-label">Business Sign Off</div>
        <div class="detail-value"
             [ngClass]="client.BUSINESS_SIGN_OFF === 'Y' ? 'field-value-yes' : 'field-value-no'">
          {{client.BUSINESS_SIGN_OFF === 'Y' ? 'YES' : 'NO'}}
        </div>
      </div>
      <div class="client-details">
        <div class="detail-label">Number of Users</div>
        <div class="detail-value">{{client.NUMBER_OF_USERS}}</div>
      </div>
      <div class="client-details">
        <div class="detail-label">Hours Spent</div>
        <div class="detail-value">{{client.HOUR_SPENT}}</div>
      </div>
      <div class="client-details extra-space">
        <div class="detail-label">Active Users</div>
        <div class="detail-value">{{client.ACTIVE_USERS}}</div>
      </div>
    </div>
  </div>
</div>

<div [hidden]="minimise" style="padding-left: 20px; padding-bottom: 5px;">
  <b>Engagement Contacts</b>
</div>
<div class="modal-foot" [hidden]="minimise">
  <div class="contact-row">
    <div class="contact-avatar">
      <svg height="85" width="80" style="margin-top: -15px;">
        <circle cx="40" cy="45" r="35" stroke-width="3" fill="#cd5763"></circle>
        <text fill="white" font-size="24" font-family="Arial"
              x="50%" y="55%" alignment-baseline="middle" text-anchor="middle">{{contactInitials}}</text>
      </svg>
    </div>
    <div class="contact-info">
      <span><b style="font-size: 18px">{{client.ENGAGMNT_CONTACT_PERSON}}</b></span><br/>
      <span><b>{{client.ENGAGMNT_CONTACT_NUMBER}}</b></span><br/>
      <span><b><a [href]="'mailto:' + client.ENGAGMNT_CONTACT_EMAIL + '?subject=Global Tax Workspace Access'"
                  style="color: #333; text-decoration: underline;">{{client.ENGAGMNT_CONTACT_EMAIL}}</a></b></span><br/>
    </div>
  </div>
  <div class="modal-foot-btn">
    <button class="btn client-modal-btn" id="launch-client" type="button"
            (click)="launchClient(client.CLIENT_KEY, '/home', 'home', 'launch-client')"
            [disabled]="crudLoading">
      @if (crudLoading === 'launch-client') {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
      Launch Client
    </button>
    <button class="btn client-modal-btn" type="button"
            (click)="launchClient(client.CLIENT_KEY, '/workspace/modules', 'workspace.modules', 'launch-executive')"
            [disabled]="crudLoading">
      @if (crudLoading === 'launch-executive') {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
      Executive Dashboards
    </button>
    <button class="btn client-modal-btn" type="button"
            (click)="launchClient(client.CLIENT_KEY, '/workspace/default', 'workspace.default', 'launch-tax-cycle')"
            [disabled]="crudLoading">
      @if (crudLoading === 'launch-tax-cycle') {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
      Tax Cycle Placemat
    </button>
    <button class="btn client-modal-btn" type="button"
            (click)="launchClient(client.CLIENT_KEY, '/workflow/list', 'workflow.list', 'launch-workflow')"
            [disabled]="crudLoading">
      @if (crudLoading === 'launch-workflow') {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
      Entity Workflow
    </button>
  </div>
</div>
